import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { isTrustedImageUrl } from "@/lib/imageTrust";
import { Leaf } from "lucide-react";

export default function StrainList() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/strains").then((r) => setList(r.data));
  }, []);

  return (
    <main className="container-narrow py-10">
      <div className="eyebrow mb-2">The catalog</div>
      <h1 className="font-serif text-4xl mb-8">Strains</h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
        {list.map((s) => (
          <Link
            key={s.slug}
            to={`/strains/${s.slug}`}
            data-testid={`strain-list-${s.slug}`}
            className="card-hover bg-card border border-border rounded-2xl overflow-hidden block"
          >
            <div className="aspect-square overflow-hidden bg-white relative">
              {isTrustedImageUrl(s.image_url) ? (
                <img
                  src={s.image_url}
                  alt={s.name}
                  className="w-full h-full object-contain"
                  loading="lazy"
                  decoding="async"
                  onError={(e) => {
                    const img = e.currentTarget;
                    const tries = parseInt(img.dataset.retry || "0", 10);
                    if (tries < 1) {
                      img.dataset.retry = String(tries + 1);
                      const sep = img.src.includes("?") ? "&" : "?";
                      img.src = `${s.image_url}${sep}r=${Date.now()}`;
                      return;
                    }
                    img.style.display = "none";
                    const fb = img.parentElement?.querySelector("[data-fb]");
                    if (fb) fb.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                data-fb
                style={{
                  display: isTrustedImageUrl(s.image_url) ? "none" : "flex",
                }}
                className="absolute inset-0 items-center justify-center bg-gradient-to-br from-secondary to-card"
              >
                <Leaf className="w-10 h-10 text-foreground/20" />
              </div>
            </div>
            <div className="p-4">
              <div className="eyebrow mb-1">{s.type}</div>
              <div className="font-serif text-lg">{s.name}</div>
              <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                {s.description}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </main>
  );
}
